module.exports = __webpack_public_path__ + "static/bouygues_logo_@2x-912bd5209924e7d14782dc1040afa749.png";